export function AuthDocs() {
    return (
      <div>
        <h2 className="fw-bold text-dark">Authentication</h2>
        <p className="text-muted">All API requests must include your API Key in the Authorization header.</p>
        
        <div className="Swal Swal-info rounded-4 border-0">
          <i className="fas fa-info-circle me-2"></i>
          Your API Key can be found in the <strong>My Apps</strong> section of your dashboard.
        </div>
  
        <div className="card bg-light border-0 rounded-4 mt-4">
          <div className="card-body p-4">
            <h6 className="fw-bold">Header Example</h6>
            <code className="text-primary">Authorization: Bearer {'<YOUR_API_KEY>'}</code>
          </div>
        </div>
      </div>
    );
  }